import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ConfigMockProps } from '../../../types/config.type'

const initialState: ConfigMockProps = {
  allergy_allergens: {},
  allergy_categories: [],
  allergy_reaction_types: [],
  allergy_reactions: [],
  allergy_severity: [],
  bed_types: [],
  capabilities: null,
  codes: [],
  departments: null,
  document_categories: [],
  document_template_variables: [],
  imaging_studies: null,
  invoice_item_category: [],
  lab_tests: null,
  medical_history_transitions: null,
  medication_transitions: null,
  mode_of_administration: [],
  note_type: [],
  occurrence: [],
  order_transitions: null,
  room_types: [],
  signee_relationship: [],
  specialties: null,
  staff_status_transitions: null,
  vitals: [],
  dosage_forms: [],
  routes: [],
  dosage_unit: [],
  unit_of_measurement: [],
  package: [],
  therapeutic_categories: [],
  sample_types: [],
  sample_bottles: [],
  lab_test_categories: []
}

const configSlice = createSlice({
  initialState,
  name: 'config',
  reducers: {
    resetConfig: () => initialState,
    setConfig: (state, { payload }: PayloadAction<ConfigMockProps>) => {
      state.specialties = payload.specialties
        ? payload.specialties?.map(specialty => ({
            id: specialty.id,
            name: specialty.name
          }))
        : null
      state.staff_status_transitions = payload.staff_status_transitions
      state.capabilities = payload.capabilities
      state.vitals = payload.vitals
      state.imaging_studies = payload.imaging_studies
      state.lab_tests = payload.lab_tests
      state.order_transitions = payload.order_transitions
      state.medication_transitions = payload.medication_transitions
      state.mode_of_administration = payload.mode_of_administration
      state.departments = payload.departments
      state.bed_types = payload.bed_types
      state.room_types = payload.room_types
      state.note_type = payload.note_type
      state.occurrence = payload.occurrence
      state.document_categories = payload.document_categories
      state.document_template_variables = payload.document_template_variables
      state.medical_history_transitions = payload.medical_history_transitions
      state.signee_relationship = payload.signee_relationship
        ? payload.signee_relationship?.map(s_r => ({
            name: s_r.name.replace(/_/g, ' ').replace(/\b(?!or\b)\w/g, l => l.toUpperCase()),
            value: s_r.value
          }))
        : []
      state.invoice_item_category = payload.invoice_item_category
      state.allergy_allergens = payload.allergy_allergens
      state.allergy_categories = payload.allergy_categories
      state.allergy_reaction_types = payload.allergy_reaction_types
      state.allergy_reactions = payload.allergy_reactions
      state.allergy_severity = payload.allergy_severity
      state.codes = payload.codes
      state.dosage_forms = payload.dosage_forms
      state.routes = payload.routes
      state.dosage_unit = payload.dosage_unit
      state.unit_of_measurement = payload.unit_of_measurement
      state.package = payload.package
      state.therapeutic_categories = payload.therapeutic_categories
      state.sample_types = payload.sample_types
      state.sample_bottles = payload.sample_bottles
      state.lab_test_categories = payload.lab_test_categories
    }
  }
})

export const { resetConfig, setConfig } = configSlice.actions
export default configSlice.reducer
